export const trading = {
    等待确认: '等待確認',
    gas矿工费: 'gas礦工費',
    审核扫描: '審核掃描',
    警报: '警報',
    无警报: '無警報',
    显示更多: '顯示更多',
    infos: "這些審計結果是由 Biking 外部實體自動執行的，它們並非建議，應與其他因素一起考慮。 Biking 不會驗證也不對通過這些外部審計員獲得的數據的質量負責，請始終進行自己的研究並諮詢多個信息來源。",
    请输数量: '請輸入數量',
    兑换: '兌換',
    价格: '價格',
    选择代币: '選擇代幣',
    搜索名称或粘贴地址: '搜索名稱或粘貼地址',
    DEXT分数: 'DEXT分數',
    更多检测: '更多檢測',
    检查审核: '檢查審核',
    令牌描述: '令牌描述',
    更新: '更新',
    合同验证: '合同驗證',
    买入税: '買入稅',
    代理合同: '代理合同',
    可造币: '可造幣',
    可修改税收: '可修改稅收',
    转让可暂停: '轉讓可暫停',
    黑名单: '黑名單',
    找回所有权: '找回所有權',
    可修改余额: '可修改餘額',
    隐藏的所有者: '隱藏的所有者',
    自毁: '自毀',
    外部呼叫风险: '外部呼叫風險',
    可以购买: '可以購買',
    最大卖出比率: '最大賣出比率',
    白名单: '白名單',
    反鲸鱼可修改: '反鯨魚可修改',
    交易冷却时间: '交易冷卻時間',
    可修改的个人税收: '可修改的個人稅收',
    真的假的代币: '真的/假的代幣',
    空投骗局: '空投騙局',
    可以信任: '可以信任',
    业主地址: '業主地址',
    所有者余额: '所有者余額',
    业主百分比: '業主百分比',
    创建者地址: '創建者地址',
    创造者余额: '創造者余額',
    创造者百分比: '創造者百分比',
    配对持有者: '配對持有者',
    其他风险: '其他風險',
    注意: '注意',
    交易: '交易',
    dex委托: 'swap委託',
    dex历史委托: 'swap歷史委託',
    kpsj: '開盤時間',
    jlks: '距離開始',
    t: '天',
    s: '時',
    f: '分',
    m: '秒',

    zgj: '最高價：',
    zdj: '最低價：',
    gflj: '官方鏈接',
    gw: '官網',
    qkllq: '區塊瀏覽器',
    scfxsj: '首次發行時間',
    fxzl: '發行總量',
    ltzl: '流通總量',
    jy: '交易',
    sj: '市價',
    tbxx: '圖表信息',
    bzgk: '幣種概況',
    jcb: '基礎版',
    ddb: '訂單表',
    zxcj: '最新成交',
  
    reload: "刷新",
    socketError: "網絡錯誤，請",
    noData: "暫無數據",
    entrustorder: "盤口",
    prices: "價格",
    quantity: "數量",
    grandtotal: "累計",
    transamount: "交易額",
    time: "時間",
    available: "可用",
    limitorder: "限價",
    plancommission: "計劃委託",
    currentcommission: "委託",
    historycommission: "歷史委託",
    completecommission: "成交委託",
    funds: '資金',
    hidetrading: "隱藏其他交易對",
    morecurrentcommission: "更多當前委託",
    morehistorycommission: "更多历史委托",
    moredocommission: "更多成交委托",
    realtimetrans: "實時成交",
    myassets: "我的資產",
    detail: "詳情",
    buyin: "買入",
    sellout: "賣出",
    login: "登錄",
    transfer: "劃轉",
    recharge: "充值",
    withdrawal: "買幣",
    quickpurchase: "法幣快捷買幣",
    default: "默認",
    ordertime: "掛單時間",
    windingtime: "上鏈時間",
    tradingpair: "交易對",
    direction: "方向",
    types: "類型",
    commissionprice: "委託價格",
    commissionnumber: "委托數量",
    dealprice: "成交均價",
    dealnumber: "成交數量",
    triggerprice: "觸發價格",
    cancelall: "全部撤單",
    averageprice: "均價",
    totalsum: "合計",
    fixedprice: "限价",
    marketprice: "市价",
    codeExpired: "二維碼已失效",
    clickRefresh: "點擊重繪",
    QRsuccessfully: "掃碼成功",
    loginInApp: "請在APP內確認登入",
    backtoQR: "返回二維碼登入",
    loginSuccess: "您已登錄成功，biking歡迎您！",
    loadingText: "載入中...",
    searchPlaceholder: "搜索",
    all: "全部",
    currency: "幣種",
    price: "最新價",
    market: "漲幅榜",
    increase: "漲幅",
    highestPrice: "最高",
    minimumPrice: "最低",
    turnover: "成交量",
    jydlb: "交易對列表",
    bzjs: "幣種介紹",
    currencyTransaction: "幣幣交易",
    leveragedTransaction: "杠桿交易",
    warning:
      "風險提示： Bitcoin Cash分叉具有極大的不確定性，交易或者投資分叉期貨代幣具有極大的風險，如果某壹條鏈缺乏礦工的支持，很可能無法存續，持有的相關代幣將有歸零風險。幣贏不為任何分叉期貨代幣的價值作出任何承諾！",
    zb: "指標",
    UpAnddown: "漲跌",
    amplitude: "振幅",
    0: "分時",
    1: "1分鐘",
    5: "5分鐘",
    15: "15分鐘",
    30: "30分鐘",
    60: "1小時",
    240: "4小時",
    3600: "1天",
    10800: "1周",
    dates: "周期：",
    password: "交易密碼",
    errorPassword: "請輸入正確交易密碼",
    worningPassword: "請輸入交易密碼",
    cancel: "取消",
    sure: "確定",
    canBuy: "可買",
    canCell: "可賣",
    withdraw: "提幣",
    otc: "OTC，法幣快速入場提現",
    enterPrice: "請輸入價格",
    sellingPrice: "賣出价",
    purchasePrice: "買入價",
    salesVolume: "賣出量",
    buyingVolume: "買入量",
    volume: "交易額",
    serviceCharge: "手續費",
    vip: "升級VIP 手續費立享折扣",
    or: "或",
    register: "註冊",
    totalPrice: "交易额不能大于",
    amountTip: "请输入正确数量",
    amountTipError: "数量不能大于",
    limitTrading: "限價交易",
    priceReminder: "價格提醒",
    SMSReminder: "簡訊提醒",
    loginAccount: "登錄賬戶",
    phone: "手機",
    phoneNum: "請輸入手機號碼",
    phoneTips: "请输入正确手机号码",
    email: "郵箱",
    emailNum: "請輸入郵箱",
    emailTips: "﻿请输入正确邮箱",
    aears: "请选择区号",
    passwordError: "请输入正确密码",
    passwordTips: "請輸入密碼",
    forgetPassword: "忘記密碼",
    noAccount: "沒有賬號",
    goRegister: "立即註冊",
    appsys: "APP掃一掃安全登入",
    xzapp: "下載最新APP",
    mmdl: "密码登陆",
    smdl: "扫码登陆",
    google: "谷歌验证器",
    nybd: "您已綁定",
    zqyzm: "请输入正确验证码",
    fsyzm: "發送驗證碼",
    flv: "費率",
    jz: "淨值",
    jzdesc1:
      "看多淨值=上個調整時點的淨值*[1+3*(現貨最新成交價-現貨上個調整時點價格)/現貨上個調整時點價格*100%]；",
    jzdesc2:
      "看空淨值=上個調整時點的淨值*[1-3*(現貨最新成交價-現貨上個調整時點價格)/現貨上個調整時點價格*100%]；",
    sbd: "三倍多",
    sbs: "三倍少",
    flvjs:
      'ETF資金費率，是平台每日對槓桿收取相應比例的管理費，來支付基金組合產生的資金費率。管理費會體現在淨值變化種，即會以"扣除相應槓桿ETF的價值"的方式呈現，且僅在新加坡時間0點收取，如果不在該時間點持有產品即不會產生費用。',
    mzsm: "免責聲明",
    ido: "我已閱讀並同意",
    exemption1: "尊敬的客户，您好！",
    exemption2:
      "感謝您登陸並使用幣贏平台（BiKing.ai）提供的公幹ETF產品和相關服務（以下簡稱“ETF產品”）。請你仔細閱讀ETF產品說明和如下風險提示，您在閱讀後繼續使用ETF產品，即視為您已經完全了解並理解ETF產品的風險，能夠承擔使用ETF產品可能帶來的損失，並視為您同意本免責聲明的全部內容。請點擊閱讀ETF產品說明：",
    exemption3: "《槓桿ETF產品FAQ》",
    exemption4: "風險提示：",
    exemption5:
      "1.您購買/出售的價格不應該較單位淨值有較大的偏差，不然您會蒙受相应的損失。",
    exemption6: "2.如果方向判斷錯誤，在極端行情下會存在價格趨近於歸零的風險。",
    exemption7:
      "幣贏平台在此鄭重的提醒您，因上述風險導致的損失或責任，均由您自行承擔，幣贏平台對此不承擔任何責任。本免責聲明與幣贏平台內的其他協議、聲明、規則等一起，構成幣贏平台與您就幣贏平台的服務和產品所達成的全部合意。",
    bzjs1: "1、“3L”表示標的交易對價格上漲1%，該產品淨值上漲3%",
    bzjs2: "2、“3S”表示標的交易對價格下跌1%，該產品淨值上漲3%",
    bzjs3: "3、淨值正常每天0點進行調整，極端行情會在盤中進行調整",
    bzjs4: "4、每倍槓桿將按天收取相應的管理費用",
    bzjs5:
      "5、交易前請注意查看淨值，該產品在極端行情下會存在價格趨近於歸零，價格遠遠偏離淨值的風險，請投資者註意控制風險",
    gdjk: "更多詳情請查看公告",
    firstTrading: "初次交易前，請先設定交易密碼",
    status: "狀態",
    status1: "待撮合",
    status2: "未成交",
    status3: "用戶撤銷",
    status4: "部分成交",
    status5: "完全成交",
    status6: "無效",
    allCancel: "批量撤銷全部委單",
    canceld: "撤單",
    cancelsuccess: "全部撤單成功,已撤[*]條委單",
    VIP1: "您的等級VIP",
    VIP2: "更為低廉的交易手續費用，更為優質的交易體驗",
    VIP3: "Taker(吃單)：",
    VIP4: "Maker(掛單)：",
    buyAmount: "買入數量不能高於",
    sellAmount: "賣出數量不能高於",
    buyAmountMin: "您的可買餘額不足",
    sellAmountMin: "您的可賣餘額不足",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/tw.js